import { render, staticRenderFns } from "./activation.vue?vue&type=template&id=d061a9ce&scoped=true&"
import script from "./activation.vue?vue&type=script&lang=js&"
export * from "./activation.vue?vue&type=script&lang=js&"
import style0 from "./activation.vue?vue&type=style&index=0&id=d061a9ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d061a9ce",
  null
  
)

export default component.exports